import { contextApp } from 'context';
import { flatRoutes, generateRegexFromUrls } from 'helpers/utils';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { urlsToCompare } from 'routes';
import useAuth from './useAuth';

const useMainLayout = (block = false) => {
 const { hash, pathname } = useLocation();
 const navigate = useNavigate();
 const isKanban = pathname.includes('kanban');

 const { isLoading, setIsLoading } = useAuth('validate'); // validateLogin,

 const {
  auth,
  routes,
  config: { isFluid, navbarPosition }
 } = contextApp();

 const isValid = async () => {
  const allowedUrl = generateRegexFromUrls(urlsToCompare).some(e => e.test(pathname));

  if (!block || allowedUrl) return setIsLoading(false);

  const isValid = await flatRoutes(routes).some(e => pathname.startsWith(e.to));
  if (!isValid) return navigate('/errors/404');
  setIsLoading(false);
 };

 useEffect(() => {
  //   if (!auth?.login) validateLogin(false, block);
  setTimeout(() => {
   if (hash) {
    const id = hash.replace('#', '');
    const element = document.getElementById(id);
    if (element) element.scrollIntoView({ block: 'start', behavior: 'smooth' });
   }
  }, 0);
 }, []);

 useEffect(() => {
  if (routes.length) isValid();
 }, [routes]);

 return { auth, isFluid, navbarPosition, isKanban, isLoading };
};

export default useMainLayout;
